import { render, staticRenderFns } from "./IndexFormModal.vue?vue&type=template&id=37b61b91"
import script from "./IndexFormModal.vue?vue&type=script&lang=js"
export * from "./IndexFormModal.vue?vue&type=script&lang=js"
import style0 from "./IndexFormModal.vue?vue&type=style&index=0&id=37b61b91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports